module.exports = __webpack_public_path__ + "img/playstart.a5212427.png";